export default __webpack_public_path__ + "static/media/841.8cacb6c3.png";